import type { FC, ReactNode, ReactElement } from 'react';

interface Props {
  condition?: boolean;
  wrapper: (children: ReactNode) => ReactElement;
  children: ReactNode;
}

const ConditionalWrapper: FC<Props> = ({ condition, wrapper, children }) => {
  return condition ? <>{wrapper(children)}</> : <>{children}</>;
};

export default ConditionalWrapper;
